import { memo } from 'react';
import { components } from 'react-select';
// import * as PropTypes from "prop-types"

import HBIcon from '../HBIcon/HBIcon';

import type {
    ClassNamesState,
    OptionsType,
    OptionTypeBase,
    SetValueAction,
    GroupTypeBase,
    Props as SelectProps,
    Theme
} from 'react-select';

import type { MouseEventHandler, Ref } from 'react';

const { Option } = components;

interface Props {
    label: string;
    isSelected: boolean;
    type: 'option';
    data: unknown;
    clearValue: () => void;
    cx: (state: ClassNamesState, className: string | undefined) => string;
    getStyles: (name: string, props: unknown) => Record<string, unknown>;
    getValue: () => OptionsType<OptionTypeBase>;
    hasValue: boolean;
    isMulti: boolean;
    isRtl: boolean;
    options: OptionsType<OptionTypeBase>;
    selectOption: (option: OptionTypeBase) => void;
    selectProps: SelectProps<
        OptionTypeBase,
        boolean,
        GroupTypeBase<OptionTypeBase>
    >;
    setValue: (
        newValue: OptionTypeBase | OptionsType<OptionTypeBase> | null,
        action: SetValueAction,
        option?: OptionTypeBase | undefined
    ) => void;
    theme: Theme;
    isDisabled: boolean;
    isFocused: boolean;
    innerRef: Ref<HTMLOptionElement>;
    innerProps: {
        id: string;
        key: string;
        onClick: MouseEventHandler<HTMLDivElement>;
        onMouseMove: MouseEventHandler<HTMLDivElement>;
        onMouseOver: MouseEventHandler<HTMLDivElement>;
        tabIndex: number;
    };
}

function HBDropdownIconOption({
    label,
    isSelected,
    innerProps,
    innerRef,
    data,

    type,
    clearValue,
    cx,
    getStyles,
    getValue,
    hasValue,
    isMulti,
    isRtl,
    options,
    selectOption,
    selectProps,
    setValue,
    theme,
    isDisabled,
    isFocused
}: Props): JSX.Element {
    return (
        <Option
            type={type}
            innerRef={innerRef}
            clearValue={clearValue}
            cx={cx}
            getStyles={getStyles}
            getValue={getValue}
            hasValue={hasValue}
            isMulti={isMulti}
            isRtl={isRtl}
            options={options}
            selectOption={selectOption}
            selectProps={selectProps}
            setValue={setValue}
            theme={theme}
            isDisabled={isDisabled}
            isFocused={isFocused}
            isSelected={isSelected}
            innerProps={innerProps}
            label={label}
            data={data}
        >
            {label}
            {isSelected && <HBIcon name="nx-check" size="large" />}
        </Option>
    );
}

export default memo(HBDropdownIconOption);
